export const genericFormatBet = (amount: string, className: string): React.ReactNode => {
  const numericAmount = Number(amount);
  const [integerPart, decimals = ''] = amount.split('.');

  // Abbreviations first (highest priority)
  if (numericAmount >= 1_000_000) {
    return `${(numericAmount / 1_000_000).toFixed(1)}M`;
  }
  if (numericAmount >= 1_000) {
    return `${(numericAmount / 1_000).toFixed(1)}K`;
  }

  // If there is no decimal part and integer length < 3 → pad with .00 or .0
  if (!decimals) {
    if (integerPart.length === 1) return `${integerPart}.00`;
    if (integerPart.length === 2) return `${integerPart}.0`;
    return integerPart; // length >= 3
  }

  // Leading zeros after decimal (visual emphasis for tiny fractions)
  const leadingZeros = decimals.match(/^0+/)?.[0]?.length || 0;
  if (leadingZeros >= 3) {
    return (
      <>
        0.0 <span className={className}>{leadingZeros}</span>
        {decimals.slice(leadingZeros)[0]}
      </>
    );
  }

  // Ensure at least 3 total numeric characters (integer + decimals)
  const totalDigits = integerPart.length + decimals.length;
  if (totalDigits < 3) {
    const needed = 3 - integerPart.length;
    const paddedDecimals = decimals.padEnd(needed, '0');
    return `${integerPart}.${paddedDecimals}`;
  }

  return amount.toString();
};
